var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// import Vue, { watch } from 'vue'
import Vue from 'vue';
import Component from 'vue-class-component';
import { component, steps } from './legal-urage-action-area/';
import { Prop, Emit, Watch } from "vue-property-decorator";
import { namespace } from 'vuex-class';
var CollectionExecutionModule = namespace('collection-execution');
var LegalUrgeActionArea = /** @class */ (function (_super) {
    __extends(LegalUrgeActionArea, _super);
    function LegalUrgeActionArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stepsArray = steps;
        _this.activeIndex = 0;
        _this.submitLoading = false;
        _this.isShow = true;
        _this.id = "";
        return _this;
    }
    LegalUrgeActionArea.prototype.emitClose = function () { };
    LegalUrgeActionArea.prototype.emitSuccess = function () {
        this.emitClose();
    };
    LegalUrgeActionArea.prototype.refreshData = function () { };
    LegalUrgeActionArea.prototype.legalRecordChange = function () {
        var _this = this;
        if (this.legalRecordId && this.legalRecordId !== "") {
            this.id = this.legalRecordId;
            this.isShow = false;
            this.$nextTick(function () {
                _this.isShow = true;
            });
        }
    };
    Object.defineProperty(LegalUrgeActionArea.prototype, "activeComponent", {
        get: function () {
            return steps[this.activeIndex].component;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 下一步
     */
    LegalUrgeActionArea.prototype.nextStep = function () {
        this.activeIndex++;
    };
    /**
     * 上一步
     */
    LegalUrgeActionArea.prototype.previousStep = function () {
        this.activeIndex--;
    };
    /**
     * 结案
     */
    LegalUrgeActionArea.prototype.finishCase = function () {
        this.activeIndex = 3;
    };
    __decorate([
        CollectionExecutionModule.Getter
    ], LegalUrgeActionArea.prototype, "collectonData", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], LegalUrgeActionArea.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], LegalUrgeActionArea.prototype, "menuChannel", void 0);
    __decorate([
        Prop({ type: String })
    ], LegalUrgeActionArea.prototype, "operatorId", void 0);
    __decorate([
        Prop()
    ], LegalUrgeActionArea.prototype, "topInfo", void 0);
    __decorate([
        Prop()
    ], LegalUrgeActionArea.prototype, "legalRecordId", void 0);
    __decorate([
        Emit('close')
    ], LegalUrgeActionArea.prototype, "emitClose", null);
    __decorate([
        Emit("success")
    ], LegalUrgeActionArea.prototype, "emitSuccess", null);
    __decorate([
        Emit("refreshData")
    ], LegalUrgeActionArea.prototype, "refreshData", null);
    __decorate([
        Watch('legalRecordId', { immediate: true })
    ], LegalUrgeActionArea.prototype, "legalRecordChange", null);
    LegalUrgeActionArea = __decorate([
        Component({
            components: __assign({}, component)
        })
    ], LegalUrgeActionArea);
    return LegalUrgeActionArea;
}(Vue));
export default LegalUrgeActionArea;
